/**
 *  Pool Widget color selection helper
 */
const getPriceChangeColor = (side?: 'buy' | 'sell') => {
  switch (side) {
  case 'buy':
    return 'text--green-600';
  case 'sell':
    return 'text--red-600';
  default:
    return 'text--grey-400';
  }
};

const getPriceChangePercentColor = (percent: number) => {
  if (percent > 0) {
    return 'text--green-600';
  }
  if (percent < 0) {
    return 'text--red-600';
  }
  return 'text--grey-400';
};

const getIssueColor = (issuesNum: number, disabled: boolean) => {
  if (disabled) {
    return 'text--grey-400';
  }
  if (issuesNum === 0) {
    return 'text--green-600';
  }
  return 'text--red-600';
};

export { getPriceChangeColor, getPriceChangePercentColor, getIssueColor };
